var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormattedNumber,_vm._b({attrs:{"prefix-label":_vm.withPrefix !== false ? _vm.currency : '',"formatter":_setup.formatter}},'FormattedNumber',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }